import S from "./styles";

const Button = S.Button;

export default Button;
